import { Link } from "react-router-dom";
import styled from "styled-components";

import * as Table from "ds/Table";
import { breakpoints, semiBoldAlias } from "Libs/theme";

const BREAKPOINT = `(min-width: ${breakpoints[1]})`;

export const Flex = styled.div<{ width: [string, string] }>`
  flex-basis: ${props => props.width[0]};

  @media ${BREAKPOINT} {
    flex-basis: ${props => props.width[1]};
  }
`;

export const TableThead = styled(Table.Thead)`
  margin-top: 24px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const TableTh = styled(Table.Th)<{ mediaWidths: [string, string] }>`
  flex-basis: ${props => props.mediaWidths[0]};

  @media ${BREAKPOINT} {
    flex-basis: ${props => props.mediaWidths[1]};
  }
`;

export const Type = styled(Flex)`
  display: flex;
  color: var(--section-ebony-color, var(--ebony));
  align-items: center;
  flex-basis: 50%;

  span {
    margin-left: 12px;
  }
`;

export const Line = styled(Link)`
  display: flex;
  ${semiBoldAlias()};
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: var(--section-snow-background-color, var(--snow));
  text-decoration: none;
  border-radius: 4px;
  color: var(--section-slate-color, var(--slate));

  &:hover {
    box-shadow: 0px 6px 24px 0px #98a0ab66;
    ${Type} {
      color: var(--section-color-primary-600-color, var(--color-primary-600));
    }
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  padding: 0;
  margin-top: 8px;
  list-style-type: none;
`;
